import type { EditCommand, EditTransaction } from "@linempo/project-domain";
import type { TimelineClipChange } from "@linempo/ui";

export function clipEdit(change: TimelineClipChange): EditCommand | EditTransaction {
  if (change.kind === "move" && change.reorderedClips) {
    return {
      label: "交换镜头顺序",
      commands: change.reorderedClips.map((clip) => ({ _tag: "MoveScene", sceneId: clip.clipId, startMs: clip.startMs })),
    };
  }
  return change.kind === "move"
    ? { _tag: "MoveScene", sceneId: change.clipId, startMs: change.startMs }
    : { _tag: "TrimScene", sceneId: change.clipId, startMs: change.startMs, endMs: change.endMs };
}
